import { gql } from "@apollo/client";

export const LIST_CURRENCIES_OPTIONS = gql`
  query listCurrenciesOptions(
    $filter: CurrencySettingFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listCurrencySettings(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        code
        decimalPlaces
        isMainCurrency
        id
        isActive
        currency {
          currency
          name
        }
      }
    }
  }
`;
export const LIST_CURRENCIES_TABLE = gql`
  query listCurrencySettings(
    $filter: CurrencySettingFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listCurrencySettings(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        code
        decimalPlaces
        isMainCurrency
        id
        isActive
        currency {
          currency
          name
        }
      }
    }
  }
`;

export const CREATE_CURRENCY = gql`
  mutation createCurrencySetting($input: CreateCurrencySettingInput!) {
    createCurrencySetting(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const UPDATE_CURRENCY = gql`
  mutation updateCurrencySetting($input: UpdateCurrencySettingInput!) {
    updateCurrencySetting(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const DISABLE_CURRENCY = gql`
  mutation disableCurrencySetting($id: ID!) {
    disableCurrencySetting(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const ENABLE_CURRENCY = gql`
  mutation enableCurrencySetting($id: ID!) {
    enableCurrencySetting(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const GET_CURRENCY_SETTING = gql`
  query getCurrencySetting($id: ID!) {
    getCurrencySetting(id: $id) {
      id
      isMainCurrency
      decimalPlaces
      code
      isActive
    }
  }
`;
